import { Button, MarkdownPreview } from '@consigli/facade';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface SummaryDescriptionProps {
  description: string;
}

/** Descriptions with more than this many paragraphs are collapsed behind "show more". */
const MAX_PARAGRAPHS_BEFORE_COLLAPSE = 2;

export const SummaryDescription: FC<SummaryDescriptionProps> = ({ description }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const paragraphs = description.split(/\n\n+/);
  const isLong = paragraphs.length > MAX_PARAGRAPHS_BEFORE_COLLAPSE;
  const content = isLong && !expanded ? paragraphs[0] : description;

  return (
    <>
      <MarkdownPreview content={content} />
      {isLong && (
        <Button
          ghost
          onClick={() => setExpanded((v) => !v)}
          className="mt-3 text-xs font-medium text-day-primary hover:underline"
        >
          {expanded ? t('findings.show-less') : t('findings.show-more')}
        </Button>
      )}
    </>
  );
};
